// Explicit boundary for application HTML (not the more restrictive email format).
// Contextual escaping at render sites remains necessary: sanitization is a second layer.
const SafeHTML = (() => {
    const purifier=DOMPurify(window);
    // Application <style> blocks carry a per-load token (styleAttr); a <style> without it came
    // from data that missed contextual escaping and is dropped, so it cannot restyle the app.
    const styleToken=crypto.randomUUID();
    const styleAttr=`data-sicaf-style="${styleToken}"`;
    purifier.addHook('uponSanitizeElement',(node,data)=>{
        if(data.tagName==='style'&&node.getAttribute?.('data-sicaf-style')!==styleToken)node.parentNode?.removeChild(node);
    });
    // DOMPurify drops name="name" (it would shadow form.name). Form fields legitimately use it
    // ("Nombre"), and the app never reads form.name, so keep exactly that value on fields.
    purifier.addHook('uponSanitizeAttribute',(node,data)=>{
        if(data.attrName==='name'&&data.attrValue==='name'&&['INPUT','SELECT','TEXTAREA'].includes(node.nodeName))data.forceKeepAttr=true;
        // The e-mail editors are contenteditable divs; DOMPurify drops the attribute, leaving them read-only.
        if(data.attrName==='contenteditable'&&data.attrValue==='true'&&node.nodeName==='DIV')data.forceKeepAttr=true;
    });
    const config={FORCE_BODY:true,ADD_TAGS:['style'],FORBID_TAGS:['script','iframe','object','embed','base','meta','link'],FORBID_ATTR:['srcdoc'],ALLOW_UNKNOWN_PROTOCOLS:false};
    function clean(value,contextTag=''){
        if(value==null||value==='')return '';
        const wrappers={TABLE:['<table>','</table>','table'],TBODY:['<table><tbody>','</tbody></table>','tbody'],THEAD:['<table><thead>','</thead></table>','thead'],TFOOT:['<table><tfoot>','</tfoot></table>','tfoot'],TR:['<table><tbody><tr>','</tr></tbody></table>','tr'],COLGROUP:['<table><colgroup>','</colgroup></table>','colgroup']};
        const wrapper=wrappers[contextTag];
        if(!wrapper)return purifier.sanitize(String(value),config);
        const fragment=purifier.sanitize(wrapper[0]+String(value)+wrapper[1],{...config,RETURN_DOM_FRAGMENT:true});
        return fragment.querySelector(wrapper[2])?.innerHTML||'';
    }
    function set(node,value){
        if(node.tagName==='STYLE'){node.textContent=String(value??'');return;}
        node.innerHTML=clean(value,node.tagName);UIEvents.mount(node);
    }
    function replace(node,value){const parent=node.parentNode;node.outerHTML=clean(value,parent?.tagName);UIEvents.mount(parent);}
    function insert(node,position,value){const parent=['beforebegin','afterend'].includes(position)?node.parentNode:node;node.insertAdjacentHTML(position,clean(value,parent?.tagName));UIEvents.mount(node.parentNode||node);}
    function fire(...args){
        if(args[0]&&typeof args[0]==='object'){
            args[0]={...args[0]};
            for(const key of ['html','title','footer','iconHtml','confirmButtonText','cancelButtonText','denyButtonText','closeButtonHtml'])if(typeof args[0][key]==='string')args[0][key]=clean(args[0][key]);
            const ready=args[0].didOpen;
            args[0].didOpen=popup=>{UIEvents.mount(popup);return ready?.(popup);};
        }else {
            if(typeof args[0]==='string')args[0]=clean(args[0]);
            if(typeof args[1]==='string')args[1]=clean(args[1]);
        }
        return Swal.fire(...args);
    }
    return {clean,set,replace,insert,fire,styleAttr};
})();
window.SafeHTML=SafeHTML;
